export const mgUses = [
  {
    img: "devops.svg",
    title: "تیم DevOps",
    title_en: "",
    desc: "تیم DevOps آبالون با پیاده‌سازی CI/CD، خودکارسازی فرآیندها و مدیریت پیکربندی زیرساخت، به سازمان‌ها کمک می‌کند تا اجرا، توسعه و به‌روز رسانی نرم‌افزارهای خود را سریع‌تر و بهینه‌تر کنند. همچنین با استفاده از طراحی معماری بهینه و اجرای مکانیزم‌های امنیتی، وابستگی به جذب نیروی متخصص کلاد کاهش یافته و هزینه‌های عملیاتی سازمان بهینه می‌شود.",
    imgAlt: "تیم DevOps",
    imgTitle: "تیم DevOps",
  },
  {
    img: "migration.svg",
    title: "مهاجرت ابری",
    title_en: "",
    desc: "مهاجرت از زیرساخت‌های سنتی به ابری، با بهینه‌سازی منابع، افزایش امنیت و ارتقای چابکی سازمان همراه است. آبالون با تیمی متخصص، این فرآیند را مطابق با نیازهای سازمان، طراحی، مدیریت و اجرا می‌کند.",
    imgAlt: "مهاجرت ابری",
    imgTitle: "مهاجرت ابری",
  },
  {
    img: "monitoring.svg",
    title: "راهکارهای مانیتورینگ",
    title_en: "",
    desc: "راهکارهای مانیتورینگ آبالون، با ثبت گزارش‌های دقیق از میزان استفاده از پردازنده، رم، فضای ذخیره‌سازی و سایر شاخص‌های کلیدی، سازمان‌ها را قادر می‌سازد تا به‌صورت لحظه‌ای سلامت سرورها، تجهیزات و سرویس‌های ابری خود را رصد کنند و از بروز مشکلات احتمالی پیشگیری کنند.",
    imgAlt: "راهکارهای مانیتورینگ",
    imgTitle: "راهکارهای مانیتورینگ",
  },
  {
    img: "kuber.svg",
    title: "کوبرنتیز سازمانی",
    title_en: "",
    desc: "راهکار کوبرنتیز سازمانی آبالون، با مدیریت خودکار کانتینرها، توزیع بار و مقیاس‌پذیری پویا، به سازمان‌ها کمک می‌کند تا با حداقل اختلال، کانتینرهای خود را مدیریت و به‌روزرسانی کنند. این راهکار به‌طور خاص برای پاسخگویی به نیازهای سازمانی طراحی شده است.",
    imgAlt: "کوبرنتیز سازمانی",
    imgTitle: "کوبرنتیز سازمانی",
  },
];

export const uses = [
  {
    img: "architect.svg",
    title: "سازمان‌های مالی، اعتباری، بورس و بیمه",
    desc: "در سازمان‌های مالی و اعتباری، امنیت داده و پایداری سرویس‌ها در اولویت قرار دارد. آبالون با رعایت الزامات پدافند غیرعامل، ایجاد ارتباطات اختصاصی بین شعب و دیتاسنترها و ارائه راهکارهای جامع مدیریت دسترسی و نظارت مداوم، بستری مطمئن برای حفظ محرمانگی داده‌ها، پردازش‌های حساس و سرویس‌دهی بدون وقفه فراهم می‌کند.",
    imgAlt: "سازمان‌های مالی، اعتباری، بورس و بیمه",
    imgTitle: "سازمان‌های مالی، اعتباری، بورس و بیمه",
  },
  {
    img: "chooseOs.svg",
    title: "صنایع مادر",
    desc: "یکی از نیازهای صنایع مادر، ایجاد ارتباط پر سرعت و ایمن بین دفاتر و کارخانه‌ها و دیتاسنترها است. آبالون امکان ارتباط چند نقطه‌ای بین مکان‌های مختلف در کشور را بر بستری ایمن و کاملا مجزا از اینترنت فراهم می‌کند. همچنین صنایع می‌توانند پیچیده‌ترین پردازش‌های طراحی و توسعه تکنولوژی‌ها و راهکارهای مدرن را به زیرساخت قدرتمند ابری بسپارند.",
    imgAlt: "صنایع مادر",
    imgTitle: "صنایع مادر",
  },
  {
    img: "panel.svg",
    title: "صنایع غذایی، دارویی",
    desc: "صنایع غذایی و دارویی می‌توانند راهکارهای ERP و SCM و نیز سیستم‌های مدیریت اینترنت اشیا خود را روی زیرساخت قدرتمند و پر سرعت آبالون اجرا کنند. همچنین راهکارهای مدیریت دسترسی IAM و PAM ارائه شده توسط آبالون امکان تعیین سطوح دسترسی کارمندان به سرویس‌ها و نظارت بر تمامی فعالیت‌های آنها را فراهم می‌آورد.",
    imgAlt: "صنایع غذایی، دارویی",
    imgTitle: "صنایع غذایی، دارویی",
  },
  {
    img: "global.svg",
    title: "سازمان‌های نوآور و مبتنی بر تکنولوژی",
    desc: "راهکارهای سازمانی آبالون به سازمان‌های نوآور کمک می‌کند تا سرویس‌های خود را به ابر منتقل کرده و با استفاده از کانتینر ارکستریشن، فرایند توسعه و اجرای نرم‌افزارها را بهینه کنند. این سازمان‌ها با زیرساخت‌های مقیاس‌پذیر، می‌توانند نیازهای هوش مصنوعی و اینترنت اشیا را پاسخ دهند و در رقابت‌های تکنولوژیک پیشرو باشند.",
    imgAlt: "سازمان‌های نوآور و مبتنی بر تکنولوژی",
    imgTitle: "سازمان‌های نوآور و مبتنی بر تکنولوژی",
  },
  {
    img: "increase.svg",
    title: "دانشگاه‌ها و آموزش آنلاین",
    desc: "دانشگاه‌ها و موسسات آموزش آنلاین که نیاز به طراحی و پیاده‌سازی سرویس‌های قابل ارائه به دانشجویان روی زیرساخت قدرتمند ابری را دارند، می‌توانند صفر تا صد این فرایند را به آبالون بسپارند. علاوه بر این سازمان‌های پژوهشی، می‌توانند به جای هزینه کردن برای زیرساخت‌های داخلی، از زیرساخت‌های ابری برای پردازش‌های پیچیده شبیه‌سازی و مدل‌سازی مبتنی بر GPU استفاده کنند.",
    imgAlt: "دانشگاه‌ها و آموزش آنلاین",
    imgTitle: "دانشگاه‌ها و آموزش آنلاین",
  },
  {
    img: "24.svg",
    title: "سازمان‌های امداد رسان",
    desc: "ارتباط امن و سرویس‌دهی همیشه در دسترس، از حیاتی‌ترین نیازهای سازمان‌های امدادی است. آبالون با فراهم کردن ارتباط کاملا ایزوله از اینترنت و در دسترس از تمام ایران، نگرانی این سازمان‌ها را برای ارتباط بین پایگاه‌های مختلف کشوری، ابر خصوصی، عمومی یا ترکیبی برطرف می‌کند. همچنین آپ‌تایم تا ۹۹.۹۹ درصد، تضمین می‌کند که سرویس‌ها همواره در دسترس خواهند بود.",
    imgAlt: "سازمان‌های امداد رسان",
    imgTitle: "سازمان‌های امداد رسان",
  },
];

export const scrubbingCenter = [
  {
    title: "سرور اختصاصی",
    desc: "سرورهای اختصاصی آبالون، زیرساختی قدرتمند و مجزا از ابر عمومی هستند که به‌صورت Bare Metal ارائه می‌شوند. سازمان‌ها می‌توانند معماری دلخواه خود را پیاده‌سازی کرده و از عملکرد بهینه سرورها بهره ببرند. همچنین، در صورت نیاز، متخصصان آبالون امکان طراحی و پیاده‌سازی معماری ابری را روی این سرورها فراهم می‌کنند.",
    imgAlt: "سرور اختصاصی",
    imgTitle: "سرور اختصاصی",
  },
  {
    title: "کولوکیشین",
    desc: "سرویس کولوکیشن آبالون به سازمان‌ها امکان می‌دهد تجهیزات خود را در دیتاسنترهای آبالون مستقر کرده و از حفاظت فیزیکی، تامین بدون وقفه برق، سیستم‌های خنک‌کننده پیشرفته و اتصال پرسرعت و پایدار به شبکه بهره‌مند شوند. این سرویس به‌صورت Bare Metal ارائه می‌شود، اما در صورت نیاز، متخصصان آبالون می‌توانند معماری ابری را روی تجهیزات کولوکیت‌شده سازمان طراحی و پیاده‌سازی کنند.",
    imgAlt: "کولوکیشین",
    imgTitle: "کولوکیشین",
  },
  {
    title: "ابر خصوصی",
    desc: "ابر خصوصی  آبالون راهکاری برای سازمان‌هایی است که می‌خواهند روی سرورهای داخلی خود، معماری ابری پیاده‌سازی کنند یا زیرساخت سنتی‌شان را به ابر منتقل کنند. تیم آبالون این فرآیند را طراحی و اجرا کرده و مدیریت متمرکز و پشتیبانی ۲۴/۷ را ارائه می‌دهد.",
    imgAlt: "ابر خصوصی",
    imgTitle: "ابر خصوصی",
  },
  {
    title: "ابر ترکیبی",
    desc: "سازمان‌هایی که زیرساخت داخلی دارند اما می‌خواهند از مزایای ابر عمومی نیز بهره‌مند شوند، می‌توانند از راهکار ابر ترکیبی آبالون استفاده کنند. این سرویس امکان ادغام زیرساخت‌های داخلی با ابر عمومی، سرور اختصاصی ابری و کولوکیشن را فراهم می‌کند. همچنین، سازمان‌ها می‌توانند با استفاده از لینک‌های اختصاصی و ایزوله از اینترنت، ارتباطی امن و سریع میان این زیرساخت‌ها برقرار کنند.",
    imgAlt: "ابر ترکیبی",
    imgTitle: "ابر ترکیبی",
  },
];

export const saveDataSolution = [
  {
    img: "plans.svg",
    name: "لوکال استوریج",
    desc: "راهکار ذخیره‌سازی سریع و منعطف مناسب برای پردازش حجم بالای درخواست‌ها",
    alt: "لوکال استوریج",
    title: "لوکال استوریج",
  },
  {
    img: "Isolation.svg",
    name: "آبجکت استوریج",
    desc: "راهکار ذخیره‌سازی مقیاس‌پذیر و جهانی برای داده‌های حجیم و غیرساختار یافته",
    alt: "آبجکت استوریج",
    title: "آبجکت استوریج",
  },
  {
    img: "HA.svg",
    name: "بکاپ و DR",
    desc: "راهکارهای پشتیبان‌گیری و بازیابی برای دسترسی به داده‌ها در شرایط بحرانی.",
    alt: "بکاپ و DR",
    title: "بکاپ و DR",
  },
  {
    img: "service.svg",
    name: "درایو ابری",
    desc: "فضای ذخیره‌سازی ابری با مدیریت ساده دسترسی کاربران و دسترسی سریع به داده‌ها از هرکجا",
    alt: "درایو ابری",
    title: "درایو ابری",
  },
  {
    img: "container.svg",
    name: "استوریج اختصاصی",
    desc: "اجرای راهکارهای اختصاصی استوریج کلاسترینگ نرم‌افزاری و سخت‌افزاری در محیط سازمان",
    alt: "استوریج اختصاصی",
    title: "استوریج اختصاصی",
  },
];

export const cloudSecurity = [
  {
    title: "ابر ایزوله",
    desc: "ابر ایزوله آبالون، ارتباطی ایزوله و کاملا مستقل از اینترنت میان سازمان شما و دیتاسنتر برقرار می‌کند. این ارتباط با پهنای باند اختصاصی و سرعتی تا ده‌ها گیگابیت بر ثانیه، امنیت داده‌ها را تضمین کرده و مورد تایید سازمان پدافند غیرعامل است.",
  },
  {
    title: "راهکار مدیریت دسترسی ممتاز (PAM)",
    desc: "راهکار «Privileged Access Management» به مدیران سازمان‌ها، امکان تعیین سطوح متنوعی از دسترسی کاربران را برای هر نرم‌افزار از جمله نرم‌افزارهای حسابداری، CRM یا ERP و محیط کامل هر سیستم‌عامل می‌دهد و از نفوذ، سرقت داده و حملات سایبری جلوگیری می‌کند.",
    imgAlt: "راهکار مدیریت دسترسی ممتاز (PAM)",
    imgTitle: "راهکار مدیریت دسترسی ممتاز (PAM)",
  },
  {
    title: "راهکار مدیریت اطلاعات و رویدادهای امنیتی (SIEM)",
    desc: "راهکار امنیتی (SIEM) آبالون با بهره‌گیری از هوش مصنوعی و یادگیری ماشین، تهدیدات سایبری را شناسایی و رفتار کاربران را تحلیل می‌کند. این سیستم با اولویت‌بندی تهدیدات، به سازمان‌ها کمک می‌کند تا در کوتاه‌ترین زمان به رویدادهای امنیتی واکنش نشان دهند و از وقوع آن‌ها پیشگیری کنند.",
    imgAlt: "راهکار مدیریت اطلاعات و رویدادهای امنیتی (SIEM)",
    imgTitle: "راهکار مدیریت اطلاعات و رویدادهای امنیتی (SIEM)",
  },
  {
    title: "راهکار مرکز عملیات امنیت (SOC)",
    desc: "راهکار SOC، نظارت مداوم بر تهدیدات سایبری را برای سازمان‌ها ممکن می‌سازد. تیم متخصصان امنیتی و سیستم‌های خودکار این مرکز، فعالیت‌های مشکوک را شناسایی و تحلیل کرده و در کوتاه‌ترین زمان به آن‌ها پاسخ می‌دهند تا از وقوع حملات جلوگیری شود.",
    imgAlt: "راهکار مرکز عملیات امنیت (SOC)",
    imgTitle: "راهکار مرکز عملیات امنیت (SOC)",
  },
];

export const services = [
  {
    img: "dashboard.svg",
    title: "محصولات سفارشی",
    cap: "از محصولات و راهکارهای سفارشی که به طور خاص برای سازمان شما طراحی و اجرا می‌شود استفاده کنید.",
    imgAlt: "محصولات سفارشی",
    imgTitle: "محصولات سفارشی",
  },
  {
    img: "sla.svg",
    title: "قرارداد منعطف",
    cap: "با عقد قرارداد سازمانی می‌‌توانید از امکان پس‌پرداخت و همچنین پرداخت‌های بلند مدت بهره‌مند شوید.",
    imgAlt: "قرارداد منعطف",
    imgTitle: "قرارداد منعطف",
  },
  {
    img: "support.svg",
    title: "پشتیبانی اختصاصی",
    cap: "با پشتیبانی سازمانی، در سریع‌ترین زمان و با بالاترین اولویت مشکلات خود را رفع کنید.",
    imgAlt: "پشتیبانی اختصاصی",
    imgTitle: "پشتیبانی اختصاصی",
  },
  {
    img: "freeSupport.svg",
    title: "اکانت منیجر اختصاصی",
    cap: "برای سرویس‌های سازمانی، اکانت منیجر اختصاصی، همه درخواست‌های شما را در آبالون پیگیری می‌کند.",
    imgAlt: "اکانت منیجر اختصاصی",
    imgTitle: "اکانت منیجر اختصاصی",
  },
];

export const abalonPopularServices = [
  {
    title: "دیتاسنتر ابری",
    desc: "دیتاسنتر ابری تمامی قابلیت‌های یک دیتاسنتر فیزیکی را روی ابر برایتان فراهم می‌کند و می‌تواند پاسخی برای پیچیده‌ترین و تخصصی‌ترین نیازهای ابری شما باشد. ",
    logo: "VPC-Service.svg",
    route: "/vpc",
    imgAlt: "دیتاسنتر ابری",
    imgTitle: "دیتاسنتر ابری",
  },
  {
    title: "شبکه توزیع محتوا (CDN)",
    desc: "با استفاده از CDN، امنیت و سرعت بارگذاری وب‌سایت خود را بهبود دهید. داده‌های شما از طریق سرورهای توزیع‌شده همیشه نزدیک‌تر به کاربران خواهند بود.",
    logo: "CloudGuard-Service.svg",
    route: "/cdn",
    imgAlt: "شبکه توزیع محتوا (CDN)",
    imgTitle: "شبکه توزیع محتوا (CDN)",
  },
  {
    title: "DNS ابری",
    desc: "با استفاده از DNS ابری، بدون نیاز به مدیریت سرورهای DNS، رکوردها و Zoneهای DNS، همه دامنه‌های خود را مدیریت و در تمام جهان منتشر کرده و سرعت پاسخ‌گویی به کاربران را افزایش دهید.",
    logo: "DNS.svg",
    route: "/dns",
    imgAlt: "DNS ابری",
    imgTitle: "DNS ابری",
  },
  {
    title: "سرویس مدیریت شده",
    desc: "تحت سرویس‌های مدیریت شده، راهکارهای اختصاصی سازمان شما در حوزه ابری، از جمله نصب سیستم‌عامل و نرم‌افزار، طراحی معماری و مهاجرت ابری اجرا می‌شود.",
    logo: "ManagedService-Service.svg",
    route: "/manageservices",
    imgAlt: "سرویس مدیریت شده",
    imgTitle: "سرویس مدیریت شده",
  },
];

export const questions = [
  {
    title: " آیا امکان مهاجرت از زیرساخت سنتی به ابر خصوصی آبالون وجود دارد؟ ",
    answer:
      "بله، تیم متخصص آبالون فرآیند مهاجرت را از طراحی تا اجرا و مدیریت انجام داده و زیرساخت شما را به‌صورت کاملاً یکپارچه به ابر خصوصی انتقال می‌دهد.",
  },
  {
    title: "تفاوت ابر خصوصی و ابر ترکیبی آبالون چیست؟",
    answer:
      "ابر خصوصی برای سازمان‌هایی طراحی شده که می‌خواهند معماری ابری را روی سرورهای داخلی خود پیاده‌سازی کنند، درحالی‌که ابر ترکیبی امکان ادغام زیرساخت داخلی با ابر عمومی را برای بهره‌مندی از انعطاف‌پذیری بیشتر فراهم می‌کند.",
  },
  {
    title: "سرورهای اختصاصی آبالون چه مزیتی دارند؟",
    answer:
      "سرورهای اختصاصی آبالون به‌صورت Bare Metal یا ابری ارائه می‌شوند که امکان مهاجرت آنی، عملکرد بهینه و امنیت بالا را برای سازمان‌ها فراهم می‌کند.",
  },
  {
    title: "آیا خدمات کولوکیشن آبالون شامل پشتیبانی فنی هم می‌شود؟",
    answer:
      "بله، سازمان‌ها علاوه بر استقرار تجهیزات خود در دیتاسنترهای آبالون، از دسترسی به شبکه و تامین برق و کولینگ پایدار و پشتیبانی ۲۴/۷ برخوردار خواهند شد.",
  },
  {
    title: "سرویس‌های مدیریت‌شده آبالون چه کمکی به سازمان‌ها می‌کند؟",
    answer:
      "با همراهی تیم متخصص DevOps، امکان مدیریت کامل زیرساخت، از کانفیگ نرم‌افزاری و سخت‌افزاری تا نظارت، بهینه‌سازی و امنیت فراهم شده و هزینه‌های عملیاتی کاهش می‌یابند.",
  },
  {
    title: "آیا مهاجرت به کوبرنتیز سازمانی پیچیده است؟",
    answer:
      "خیر، پلتفرم ابری آبالون، فرآیند مدیریت و استقرار کانتینرها را خودکار کرده و امکان راه‌اندازی کوبرنتیز در کوتاه‌ترین زمان ممکن را فراهم می‌کند.",
  },
  {
    title: "چگونه راهکارهای ذخیره‌سازی آبالون به نیازهای سازمانی پاسخ می‌دهد؟",
    answer:
      "راهکارهای متنوع از جمله لوکال استوریج، آبجکت استوریج، درایو ابری و نیز پیاده‌سازی راهکارهای اختصاصی داخل سازمان‌ها، امکان ذخیره‌سازی منعطف، مقیاس‌پذیر و ایمن را برای داده‌های سازمانی فراهم می‌کنند.",
  },
  {
    title: "آیا آبالون خدمات امنیتی اختصاصی برای سازمان‌ها ارائه می‌دهد؟",
    answer:
      "بله، با خدماتی مانند حفاظت در برابر DDoS، فایروال و WAF، امنیت سرویس‌های سازمانی را با نظارت ۲۴/۷ بر عهده می‌گیرد.",
  },
  {
    title: "راهکار مرکز عملیات امنیت (SOC) آبالون چه کمکی به سازمان‌ها می‌کند؟",
    answer:
      "SOC آبالون با شناسایی، تحلیل و پاسخ به تهدیدات امنیتی به‌صورت متمرکز و خودکار، از حملات سایبری جلوگیری کرده و امنیت سازمان را افزایش می‌دهد.",
  },
];
